import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_8070_183597)">
      <path
        d="M0.822708 8.80159C0.954822 10.0365 1.94799 11.0296 3.18225 11.1672C5.07807 11.3785 6.92186 11.3785 8.81765 11.1672C10.0519 11.0296 11.0451 10.0365 11.1772 8.80159C11.2747 7.89001 11.3571 6.95413 11.3571 5.99999C11.3571 5.04586 11.2747 4.10998 11.1772 3.1984C11.0451 1.96356 10.0519 0.97038 8.81765 0.832804C6.92186 0.621487 5.07807 0.621487 3.18225 0.832804C1.94799 0.97038 0.954822 1.96356 0.822708 3.1984C0.725179 4.10998 0.642822 5.04586 0.642822 5.99999C0.642822 6.95413 0.72518 7.89001 0.822708 8.80159Z"
        fill="white"
        stroke="#070F21"
      />
      <path d="M7.5152 4.48486L4.48474 7.51532" stroke="#070F21" strokeLinecap="round" />
      <path d="M7.5152 7.51532L4.48474 4.48486" stroke="#070F21" strokeLinecap="round" />
    </g>
    <defs>
      <clipPath id="clip0_8070_183597">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const DeleteIcon = memo(ForwardRef);
export default DeleteIcon;
